import { ResetPasswordWindow } from '../sharedcomponents/ResetPasswordWindow';
import * as React from 'react';
import $ from 'jquery';

interface ResetPasswordState {
    Username: string
}

export class ResetPassword extends React.Component<any, ResetPasswordState> {
    constructor(props: any) {
        super(props);
        this.state = { Username: this.props.userName };
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.userName != null)
            this.setState({ Username: nextProps.userName });
    }

    disableResetPassword() {
        this.props.disableResetPassword();
    }
    disableResetWindow() {
        this.props.disableResetWindow();
    }
    closeReset() {
        this.props.disableResetWindow();
        //$("#resetPasswordModel").css("display", "none");
    }

    public render() {
        var divStyle = {
            display: 'block'
        }

        return <div className="modal fade show" data-backdrop="false" id="resetPasswordModel" role="dialog" style={divStyle} >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
 <h5 className="modal-title">Reset Your Password</h5>
                        <button type="button" onClick={this.closeReset.bind(this)} className="btn-close" data-bs-dismiss="modal">&times;</button>
                       
                    </div>
                    <div className="modal-body" >
                        <ResetPasswordWindow disableResetPassword={this.disableResetPassword.bind(this)} disableResetWindow={this.disableResetWindow.bind(this)} userName={this.state.Username} />
                    </div>
                </div>
            </div>
        </div>;
    }
}

